// components/ui/CardContainer.jsx
const CardContainer = ({
  children,
  headerContent,
  paginationControls,
  loading = false,
}) => {
  return (
    <div className="card bg-base rounded-3 h-100 py-2" >
      <div className=" border-bottom  py-3 px-4 d-flex align-items-center flex-wrap">
        {headerContent}
      </div>
      <div className=" p-24">
        <div
          className="position-relative"
          style={{ minHeight: loading ? "500px" : undefined }}
        >
          <div className="table-responsive scroll-sm">{children}</div>
        </div>
      </div>
      <div className="  py-3 px-4 mx-5">{paginationControls}</div>
    </div>
  );
};

export default CardContainer;
